import { z } from "zod";
import { BANNED_WORD_SEVERITY_VALUES } from "./banned-word.js";

export const MODERATION_EVENT_CONTEXT_VALUES = [
	"post_caption",
	"post_overlay_text",
	"comment",
	"story_caption",
	"story_comment",
	"dm",
	"group_name",
	"group_description",
	"nickname",
] as const;
export const ModerationEventContext = {
	POST_CAPTION: "post_caption",
	POST_OVERLAY_TEXT: "post_overlay_text",
	COMMENT: "comment",
	STORY_CAPTION: "story_caption",
	STORY_COMMENT: "story_comment",
	DM: "dm",
	GROUP_NAME: "group_name",
	GROUP_DESCRIPTION: "group_description",
	NICKNAME: "nickname",
} as const;
export type ModerationEventContext = (typeof MODERATION_EVENT_CONTEXT_VALUES)[number];

export const MODERATION_EVENT_ACTION_VALUES = ["masked", "blocked"] as const;
export const ModerationEventAction = {
	MASKED: "masked",
	BLOCKED: "blocked",
} as const;
export type ModerationEventAction = (typeof MODERATION_EVENT_ACTION_VALUES)[number];

export const moderationEventMatchedWordSchema = z.object({
	word: z.string(),
	severity: z.enum(BANNED_WORD_SEVERITY_VALUES),
});
export type ModerationEventMatchedWord = z.infer<typeof moderationEventMatchedWordSchema>;

export const moderationEventSchema = z.object({
	id: z.string(),
	user_id: z.string(),
	group_id: z.string().nullable(),
	context: z.enum(MODERATION_EVENT_CONTEXT_VALUES),
	resource_id: z.string().nullable(),
	action: z.enum(MODERATION_EVENT_ACTION_VALUES),
	matched_words: z.array(moderationEventMatchedWordSchema),
	original_text: z.string().nullable(),
	created_at: z.union([z.date(), z.string()]),
});
export type ModerationEvent = z.infer<typeof moderationEventSchema>;

export const listModerationEventsQuerySchema = z.object({
	limit: z.coerce.number().int().min(1).max(200).default(50),
	offset: z.coerce.number().int().min(0).default(0),
	action: z.enum(MODERATION_EVENT_ACTION_VALUES).optional(),
	context: z.enum(MODERATION_EVENT_CONTEXT_VALUES).optional(),
	group_id: z.string().optional(),
	user_id: z.string().optional(),
});
export type ListModerationEventsQuery = z.infer<typeof listModerationEventsQuerySchema>;
